import { Button, Typography } from "@mui/material";
import { RadioList, TextField } from "ds-form";
import { Formik, Form, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import '../styles/SlideInteractor.css';
import { useAlert } from "react-common";

const SlideInteractor = ({socket, activeSlide, presentationID, userID, timeIsUp, remainingResponse }) => {

    const [attendeeData, setAttendeeData] = useState();
    const { t } = useTranslation();
    const [numberResponsePossible, setNumberResponsePossible] = useState();
    const alert = useAlert();

    useEffect(() => {
        if(remainingResponse){
            const foundUser = remainingResponse.find(user => user.userID === userID);
            setNumberResponsePossible(foundUser.remainingResponse)    
        }
    }, [remainingResponse, userID])

    const handleSubmit = () => {
        const dataToSend = {
            module : "AttendeeData",
            method : "send",
            options : {
                activeSlideID: activeSlide.id,
                presentationID : presentationID,
                userID: userID,
                data : attendeeData?.value || attendeeData
            }
        }
        setNumberResponsePossible((prevState) => prevState - 1)
        socket.send(JSON.stringify(dataToSend))       
    };
    
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={{
                    attendeeData: null
                }}
                validate={(values) => {
                    let errors = {};

                    if(!attendeeData){
                        errors.attendeeData = t("responseRequired")
                    }

                    return errors; 
                }}
                onSubmit={(values, { resetForm }) => {
                    handleSubmit();
                    resetForm()
                    alert.success(t('responseSent'))
                    setAttendeeData(null)
                    }
                }    
            >
                <Form className="slideInteractorForm">
                    <Typography variant="h4">{activeSlide.configuration.question}</Typography>
                    {activeSlide.type === 1 &&
                        <div className="responseContainer">
                            <Typography variant="h6">{t('enterResponse')}</Typography>
                            <TextField
                                name="attendeeData.word" 
                                label={t("yourResponse")}
                                onChange={setAttendeeData} 
                                inputProps={{ maxLength: 25 }}
                            />
                        </div>
                    }
                    {(activeSlide.type === 2 || activeSlide.type === 3) &&
                        <div className={`responseContainer center`}>
                            <Typography variant="h6">{t('selectResponse')}</Typography>
                            <RadioList
                                readOnly={numberResponsePossible === 0}
                                value={attendeeData} 
                                options={activeSlide.configuration.options.map((x) => ({ value: x, label: x }))} 
                                onChange={(newValue)=>setAttendeeData(newValue)} 
                                orientation="vertical" 
                            />     
                        </div>
                    }
                    <Button type="submit" variant="contained" color="primary" disabled={timeIsUp || numberResponsePossible === 0}>{t('send')}</Button>
                    <div className="errorMessage">
                        <ErrorMessage name="attendeeData" />
                    </div>
                </Form>
            </Formik>
        </>
    )
}

export default SlideInteractor;